var BUTHelper = window.BUTHelper || {};

var TRAP_FOCUS_HANDLERS = {};

BUTHelper.fetchConfigHTTP = {
  method: "POST",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/javascript",
  },
};

BUTHelper.fetchConfigJSON = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

// Shopify search matches loosely (related products, any term) unless a word is quoted.
// Quote each word so every term must match; keepLastOpen leaves the last word unquoted
// so prefix matching still works while typing.
BUTHelper.exactSearchQuery = function (query, keepLastOpen) {
  const term = (query || "").trim();
  if (!term || /[":]/.test(term)) return term;
  const words = term.split(/\s+/);
  return words
    .map((word, index) => (keepLastOpen && index === words.length - 1 ? word : `"${word}"`))
    .join(" ");
};

document.addEventListener("submit", function (event) {
  const form = event.target;
  if (event.defaultPrevented || !form.matches('form[role="search"]')) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  const query = BUTHelper.exactSearchQuery(input.value);
  if (!query || query === input.value) return;
  event.preventDefault();
  const params = new URLSearchParams(new FormData(form));
  params.set("q", query);
  window.location.assign(`${form.getAttribute("action")}?${params.toString()}`);
});

BUTHelper.debounce = function (fn, delay) {
  let id = null;
  return function (args) {
    clearTimeout(id);
    id = null;
    id = setTimeout(function () {
      fn.call(this, args);
    }, delay);
  };
};

BUTHelper.removeTrapFocus = function (elementToFocus = null) {
  document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);
  document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);

  if (elementToFocus) elementToFocus.focus();
};

BUTHelper.trapFocus = function (element, elementToFocus = element) {
  let focusableEls = element.querySelectorAll(
    `a[href]:not([disabled]):not(.disable), [tabindex]:not([tabindex^='-']), summary, button:enabled:not([tabindex^='-']), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [draggable], area`
  );

  let firstFocusableEl = focusableEls[0];

  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  // console.log(element, firstFocusableEl, lastFocusableEl);

  // console.log(focusableEls);

  let KEYCODE_TAB = 9;

  BUTHelper.removeTrapFocus();

  TRAP_FOCUS_HANDLERS.focusin = (event) => {
    if (
      event.target !== element &&
      event.target !== lastFocusableEl &&
      event.target !== firstFocusableEl
    )
      return;

    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.focusout = function () {
    document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.keydown = function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (e.target === element || e.target === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);

  elementToFocus.focus();
};

BUTHelper.isColor = function (strColor) {
  let s = new Option().style;
  s.color = strColor;
  return s.color == strColor;
};

BUTHelper.isHexColor = function (color) {
  return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(color);
};

BUTHelper.isImage = function (url) {
  return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(
    url
  );
};

BUTHelper.formatMoney = function (cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.theme_variables.settings.money_format;

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = BUTHelper.formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = BUTHelper.formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = BUTHelper.formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = BUTHelper.formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = BUTHelper.formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = BUTHelper.formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = BUTHelper.formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = BUTHelper.formatWithDelimiters(cents, 0, "'");
      break;
  }
  value = value.replace(/\.00$/, "").replace(/,00$/, "");
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

BUTHelper.defaultTo = function (value2, defaultValue) {
  return value2 == null || value2 !== value2 ? defaultValue : value2;
};

BUTHelper.formatWithDelimiters = function (
  number,
  precision,
  thousands,
  decimal
) {
  precision = BUTHelper.defaultTo(precision, 2);
  thousands = BUTHelper.defaultTo(thousands, ",");
  decimal = BUTHelper.defaultTo(decimal, ".");
  if (isNaN(number) || number == null) {
    return 0;
  }
  number = (number / 100).toFixed(precision);
  let parts = number.split("."),
    dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    ),
    centsAmount = parts[1] ? decimal + parts[1] : "";
  return dollarsAmount + centsAmount;
};

BUTHelper.preventStickyHeaderReveal = function () {
  let stickyHeader = BUTHelper.qs("but-header-sticky");
  stickyHeader &&
    stickyHeader.dispatchEvent(new Event("preventStickyHeaderReveal"));
};
BUTHelper.loadScript = function (id, file, callback) {
  if (!BUTHelper.qs(`#${id}`)) {
    let script = document.createElement("script");
    script.setAttribute("src", `${file}`);
    script.setAttribute("id", `${id}`);
    script.onload = function () {
      callback();
    };
    script.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        callback();
      }
    };
    script.onerror = function (event) {
      console.log("Failed to load script file " + file, event);
      callback();
    };
    document.body.appendChild(script);
  } else {
    callback();
  }
};
var VAR_LOCALIZATION_CACHE = new Map();

class BUTElementLazyLoad {
  constructor() {
    this.elements = BUTHelper.qsa(".js-main-body .js-animate");
    this.viewportHeight = window.innerHeight;
    this.setupEventListeners();
  }

  setupEventListeners() {
    const longObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "-48px" }
    );

    const shortObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    this.elements.forEach((element) => {
      const height = element.offsetHeight;
      if (height > this.viewportHeight * 0.8) {
        longObserver.observe(element);
      } else {
        shortObserver.observe(element);
      }
    });
  }
}
setTimeout(() => {
  typeof BUTElementLazyLoad !== "undefined" && new BUTElementLazyLoad();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    typeof BUTElementLazyLoad !== "undefined" && new BUTElementLazyLoad();
  });
}

class BUTCustomComponent extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }
}

class BUTAccordion extends BUTCustomComponent {
  constructor() {
    super();
    this.properties = this.dataset.properties
      ? JSON.parse(this.dataset.properties)
      : {};
    this.accordionItems = this.$$(".js-accordion-item");
    this.accordionTriggers = this.$$(".js-accordion-trigger");
    this.accordionContents = this.$$(".js-accordion-content");
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.accordionTriggers.forEach((ele) => {
      ele.addEventListener("click", (e) => {
        e.preventDefault();
        this.onTriggerClick(e.currentTarget);
      });
    });
    this.onResize();
  }

  onResize() {
    this.resizeObserver = new ResizeObserver((entries) => {
      this.accordionItems.forEach((e) => {
        if (
          e.querySelector(".js-accordion-trigger").classList.contains("open")
        ) {
          const content = e.querySelector(".js-accordion-content");
          // Use requestAnimationFrame for smooth resize updates
          requestAnimationFrame(() => {
            content.style.maxHeight = `${this.calculateMaxHeightContent(content)}px`;
          });
        }
      });
    });
    this.resizeObserver.observe(this);
  }

  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";
    if (this.properties.multiple === true) {
      this.toggleAll();
    }
    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);

    let content = this.$(`#${e.getAttribute("aria-controls")}`);

    /*
     * Height animates on max-height (CSS transition on '.accordion-content'). A panel that
     * starts open has 'max-height: auto', which cannot transition, so it is pinned to its
     * pixel height and a reflow is forced before the target is set. The children only fade
     * and shift a few pixels (CSS) instead of being translated by the panel's full height.
     */
    content.style.maxHeight = `${content.getBoundingClientRect().height}px`;
    content.offsetHeight;

    if (open) {
      e.classList.add("open");
      content.classList.add("open");
      content.style.maxHeight = `${this.calculateMaxHeightContent(content)}px`;
    } else {
      e.classList.remove("open");
      content.classList.remove("open");
      content.style.maxHeight = `0px`;
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  toggleAll() {
    this.accordionTriggers.forEach((ele) => {
      ele.setAttribute("aria-expanded", `false`);
      ele.classList.remove(`open`);
    });

    this.accordionContents.forEach((ele) => {
      ele.classList.remove("open");
      ele.style.maxHeight = `0px`;
    });
  }

  calculateMaxHeightContent(target) {
    return target.scrollHeight;
  }
}

customElements.define("but-accordion", BUTAccordion);

class BUTDropdownSelect extends BUTCustomComponent {
  constructor() {
    super();
    this.selectElement = this.querySelector("select");
    this.selectedItemDiv = document.createElement("div");
    this.optionsContainerDiv = document.createElement("div");
    this.observer = new MutationObserver(this.handleMutations.bind(this));
  }

  connectedCallback() {
    this.init();
    this.observeSelectElement();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  init() {
    this.setAttribute("role", "combobox");
    this.setAttribute("aria-haspopup", "listbox");
    this.setAttribute("aria-expanded", "false");

    this.selectedItemDiv.classList.add("select-selected");
    this.selectedItemDiv.setAttribute("role", "button");
    this.selectedItemDiv.setAttribute("tabindex", "0");
    this.selectedItemDiv.setAttribute("aria-label", "Select option");

    this.optionsContainerDiv.classList.add("select-items", "select-hide");
    this.optionsContainerDiv.setAttribute("role", "listbox");

    this.updateSelectedItem();
    this.populateOptions();
    this.addEventListeners();
    this.appendChild(this.selectedItemDiv);
    this.appendChild(this.optionsContainerDiv);
  }

  updateSelectedItem() {
    this.selectedItemDiv.textContent =
      this.selectElement.options[this.selectElement.selectedIndex]
        ?.textContent || "";
  }

  createCheckmarkSVG() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("width", "15");
    svg.setAttribute("height", "15");
    svg.setAttribute("viewBox", "0 0 15 15");
    svg.setAttribute("fill", "none");
    
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M12.0581 3.30806C12.3021 3.06398 12.6978 3.06398 12.9418 3.30806C13.1859 3.55214 13.1859 3.94777 12.9418 4.19185L6.06685 11.0668C5.82277 11.3109 5.42714 11.3109 5.18306 11.0668L2.05806 7.94185C1.81398 7.69777 1.81398 7.30214 2.05806 7.05806C2.30214 6.81398 2.69777 6.81398 2.94185 7.05806L5.62495 9.74116L12.0581 3.30806Z");
    path.setAttribute("fill", "#181918");
    
    svg.appendChild(path);
    return svg;
  }

  populateOptions() {
    this.optionsContainerDiv.innerHTML = ""; // Clear existing options
    Array.from(this.selectElement.options).forEach((option, index) => {
      const optionItemDiv = document.createElement("div");
      optionItemDiv.classList.add("select-item");
      optionItemDiv.setAttribute("role", "option");
      optionItemDiv.setAttribute("tabindex", "0");
      optionItemDiv.setAttribute("aria-selected", "false");
      
      const isSelected = index === this.selectElement.selectedIndex;
      
      // Create checkmark SVG
      const checkmarkSVG = this.createCheckmarkSVG();
      checkmarkSVG.classList.add("select-item-checkmark");
      if (!isSelected) {
        checkmarkSVG.classList.add("d-none-important");
      }
      
      // Create text span
      const textSpan = document.createElement("span");
      textSpan.textContent = option.textContent;
      
      // Append SVG and text to option item
      optionItemDiv.appendChild(textSpan);
      optionItemDiv.appendChild(checkmarkSVG);
      
      optionItemDiv.dataset.index = index;
      if (isSelected) {
        optionItemDiv.setAttribute("aria-selected", "true");
      }
      optionItemDiv.addEventListener("click", () => {
        this.handleOptionClick(index);
      });

      this.optionsContainerDiv.appendChild(optionItemDiv);
    });
  }

  addEventListeners() {
    this.selectedItemDiv.addEventListener("click", (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });

    // document.addEventListener("click", () => this.closeAllDropdowns());

    this.selectedItemDiv.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.toggleDropdown();
      }
    });

    this.addEventListener("keydown", (event) => {
      const options = this.optionsContainerDiv.querySelectorAll(".select-item");
      const currentIndex = Array.from(options).findIndex(
        (opt) => opt === document.activeElement
      );

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          if (currentIndex < options.length - 1) {
            options[currentIndex + 1].focus();
          }
          break;
        case "ArrowUp":
          event.preventDefault();
          if (currentIndex > 0) {
            options[currentIndex - 1].focus();
          }
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          if (document.activeElement.classList.contains("select-item")) {
            this.handleOptionClick(
              parseInt(document.activeElement.dataset.index)
            );
          }
          break;
        case "Escape":
          this.closeAllDropdowns();
          this.selectedItemDiv.focus();
          break;
      }
    });
  }

  handleOptionClick(index) {
    this.selectElement.selectedIndex = index;
    this.selectElement.dispatchEvent(new Event("change", { bubbles: true }));
    this.updateSelectedItem();
    this.updateCheckmarkVisibility();
    this.closeAllDropdowns();
  }

  updateCheckmarkVisibility() {
    const options = this.optionsContainerDiv.querySelectorAll(".select-item");
    options.forEach((optionItem, index) => {
      const checkmark = optionItem.querySelector(".select-item-checkmark");
      if (checkmark) {
        const isSelected = index === this.selectElement.selectedIndex;
        if (isSelected) {
          checkmark.classList.remove("d-none-important");
        } else {
          if (!checkmark.classList.contains("d-none-important")) {
            checkmark.classList.add("d-none-important");
          }
        }
        optionItem.setAttribute("aria-selected", isSelected.toString());
      }
    });
  }

  toggleDropdown() {
    const isExpanded =
      !this.optionsContainerDiv.classList.contains("select-hide");
    this.setAttribute("aria-expanded", (!isExpanded).toString());
    BUTHelper.qsa(".select-items").forEach((item) => {
      if (!this.contains(item)) {
        item.classList.add("select-hide");
      }
    });
    BUTHelper.qsa(".select-selected").forEach((item) => {
      if (!this.contains(item)) {
        item.classList.remove("select-arrow-active");
      }
    });

    this.optionsContainerDiv.classList.toggle("select-hide");
    this.selectedItemDiv.classList.toggle("select-arrow-active");
  }

  closeAllDropdowns() {
    BUTHelper.qsa(".select-items").forEach((item) =>
      item.classList.add("select-hide")
    );
    BUTHelper.qsa(".select-selected").forEach((selected) =>
      selected.classList.remove("select-arrow-active")
    );
  }

  observeSelectElement() {
    this.observer.observe(this.selectElement, {
      childList: true, // Listen for added/removed options
      subtree: false,
    });
  }

  handleMutations(mutations) {
    let optionsChanged = false;
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        optionsChanged = true;
      }
    });

    if (optionsChanged) {
      this.populateOptions();
      this.updateSelectedItem();
      this.updateCheckmarkVisibility();
    }
  }
}

customElements.define("but-select", BUTDropdownSelect);